<template>
  <svg
    width="14px"
    height="14px"
    viewBox="0 0 14 14"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>Users</title>
    <!-- Modified to accept a CSS fill -->
    <g
      id="UsersIcon"
      class="override-fill"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd">
      <circle
        id="Oval-10"
        class="override-stroke"
        stroke="none"
        fill-rule="nonzero"
        cx="10"
        cy="3"
        r="2"/>
      <circle
        id="Oval-10-Copy"
        class="override-stroke"
        stroke="none"
        fill-rule="nonzero"
        cx="4"
        cy="3"
        r="2"/>
      <path
        id="Rectangle-20"
        class="override-stroke"
        d="M3,7 L5,7 C6.1045695,7 7,7.8954305 7,9 L7,13 L1,13 L1,9 C1,7.8954305 1.8954305,7 3,7 Z"
        stroke="none"
        fill-rule="nonzero"/>
      <!-- eslint-disable max-len -->
      <path
        id="Rectangle-20-Copy"
        class="override-stroke"
        d="M9,7 L11,7 C12.1045695,7 13,7.8954305 13,9 L13,13 L7,13 L7,9 C7,7.8954305 7.8954305,7 9,7 Z"
        stroke="none"
        fill-rule="nonzero"/>
    <!-- eslint-enable max-len -->
    </g>
  </svg>
</template>

<script>
export default {
  name: 'UsersIcon',
}
</script>



// WEBPACK FOOTER //
// src/components/navigation/icons/UsersIcon.vue